import { FormGroup, FormControl, Validators } from '@angular/forms';

// core
import { FlagsHelper } from '../../../core/library/flags-helper';

// own
import { JssTreeNodeType, FormLayout, JssTreeNodeObjectSubType } from './jss-types';
import { JssTreeObject } from './jss-tree-object';

export class JssTreeObjectForm extends JssTreeObject {

   private _formTitle = '';
   private _formSubtitle = '';

   constructor(
      nodeName: string,
      nodeObjectSubType: JssTreeNodeObjectSubType = 'OBJECT_FORM'
   ) {
      super(nodeName, nodeObjectSubType);
   }

   public set formTitle(title: string) {this._formTitle = title; }
   public get formTitle(): string {return this._formTitle; }
   public set formSubtitle(subtitle: string) {this._formSubtitle = subtitle; }
   public get formSubtitle(): string {return this._formSubtitle; }
   public hasFormTitle(): boolean {return this._formTitle.length > 0; }
   public hasFormSubtitle(): boolean {return this._formSubtitle.length > 0; }

   public recveGenFormTree(form: FormGroup = null) {
      // parent FormGroup
      if (form) {
         console.warn('JssTreeObjectForm: FormGroup from parent should be null');
      }

      this._formGroup = new FormGroup({});
      // add to parent object if available
      if (form) {
         form.addControl(this._nodeName, this._formGroup);
      }
      for (const item of this._children) {
         item.recveGenFormTree(this._formGroup);
      }
   }

   /**
   * Erzeugt ein JS Object mit dem Inhalt der Form sowie den Hidden-pass-through Daten.
   *
   * @param data: any
   * @returns void
   */
   public recveCreateDataObject(data: any) {
      // pass through
      for (const item of this._children) {
         item.recveCreateDataObject(data);
      }
   }

   public recveDumpJssTree(indent: string) {
      let s = indent + this._nodeName +
         '<' + this._nodeType + ',' + this._nodeObjectSubType + '>=';
      if (this.hasTitle()) {
         s += 'Title:' + this._title;
      }
      if (this.isRequired()) {
         s += ',<Requ>';
      }
      if (this._formGroup) {
         s += ',CtrlValue:ja';
      }
      console.log(s);

      // children
      for (const item of this._children) {
         item.recveDumpJssTree(indent + '  ');
      }
   }

}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/core/json-form/model/jss-tree-object-form.ts